import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { strings } from "@/i18n";

export const Footer = () => {
  const { lang } = useLanguage();
  const s = strings.footer[lang];

  return (
    <footer className="bg-bordeaux text-ivory" data-testid="footer">
      <div className="mx-auto max-w-6xl px-6 py-16 md:px-8 md:py-20">
        <div className="flex flex-col items-center text-center">
          <p className="font-serif text-2xl font-medium tracking-[0.4em] md:text-3xl" data-testid="footer-logo">
            ROGANEL
          </p>
          <div className="mt-5 flex items-center gap-4" aria-hidden="true">
            <span className="h-px w-12 bg-ivory/40" />
            <span className="h-2 w-2 rotate-45 bg-ivory/70" />
            <span className="h-px w-12 bg-ivory/40" />
          </div>
          <p className="mt-5 font-serif text-lg italic text-ivory/85">
            {s.tagline}
          </p>
          <p className="mt-8 font-sans text-xs font-light leading-relaxed tracking-wide text-ivory/70" data-testid="footer-address">
            23 rue des Archives — 75004 Paris
            <br />
            <a href="tel:+33140290220" className="transition-colors duration-300 hover:text-ivory" data-testid="footer-phone-link">
              {s.phone}
            </a>
          </p>
          <a
            href="https://www.instagram.com/roganel75004"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="mt-6 inline-flex items-center gap-3 border border-ivory/40 px-6 py-3 font-sans text-[11px] font-medium uppercase tracking-[0.25em] text-ivory transition-[background-color,color,border-color] duration-300 hover:border-ivory hover:bg-ivory hover:text-bordeaux"
          >
            <Instagram size={14} strokeWidth={1.5} />
            @roganel75004
          </a>
          <nav className="mt-12 flex flex-wrap items-center justify-center gap-x-8 gap-y-3" data-testid="footer-nav">
            <Link to="/notre-histoire" data-testid="footer-link-histoire" className="font-sans text-[10px] uppercase tracking-[0.25em] text-ivory/60 transition-colors duration-300 hover:text-ivory">
              {s.histoire}
            </Link>
            <Link to="/70ans" data-testid="footer-link-livret" className="font-sans text-[10px] uppercase tracking-[0.25em] text-ivory/60 transition-colors duration-300 hover:text-ivory">
              {s.livret}
            </Link>
            <Link to="/la-boutique" data-testid="footer-link-boutique" className="font-sans text-[10px] uppercase tracking-[0.25em] text-ivory/60 transition-colors duration-300 hover:text-ivory">
              {s.boutique}
            </Link>
            <Link to="/livre-d-or" data-testid="footer-link-livre-or" className="font-sans text-[10px] uppercase tracking-[0.25em] text-ivory/60 transition-colors duration-300 hover:text-ivory">
              {s.livreOr}
            </Link>
            <Link to="/photos-videos" data-testid="footer-link-photos" className="font-sans text-[10px] uppercase tracking-[0.25em] text-ivory/60 transition-colors duration-300 hover:text-ivory">
              {s.photos}
            </Link>
          </nav>
        </div>
      </div>
      <div className="border-t border-ivory/15 py-6 text-center">
        <p className="font-sans text-[10px] uppercase tracking-[0.3em] text-ivory/50" data-testid="footer-copyright">
          © 2026 Roganel — Paris · Le Marais
        </p>
      </div>
    </footer>
  );
};
